export enum AlarmType {
  ALARM = 'ALARM',
  EVENT = 'EVENT',
  MAINTENANCE = 'MAINTENANCE'
}
